import Cookies from 'js-cookie';

class AuthService {
  storeToken(token) {
    try {
      Cookies.set('userToken', token, { expires: 1 / 24, sameSite: 'Strict', secure: process.env.NODE_ENV === 'production' });
    } catch (error) {
      console.error('Error storing token:', error.message);
    }
  }

  getToken() {
    try {
      const token = Cookies.get('userToken');
      return token;
    } catch (error) {
      console.error('Error retrieving token:', error.message);
      return null;
    }
  }

  removeToken() {
    try {
      Cookies.remove('userToken', { sameSite: 'Strict', secure: true });
    } catch (error) {
      console.error('Error removing token:', error.message);
    }
  }
}

const authService = new AuthService();
export default authService;